module.exports = __webpack_public_path__ + "static/media/mbcet_logo.c1914200.png";